'use client'

/* Click-to-enlarge for the DEDICATED shaheed/adopt page galleries. REUSES the main
   profile's PhotoLightbox (no fork) as a pure view-layer overlay: this client component
   renders the exact same classed <figure> markup the server pages rendered — their global
   <style> tags still apply to it — adding only a zoom button-wrap per image plus the
   lightbox. Both pages' CSS targets `.x-gallery img` (descendant), so the button in
   between changes nothing visually. */

import { useState } from 'react'
import PhotoLightbox from './[slug]/PhotoLightbox'
import { masjidPlaceholder } from '../../lib/masjid-placeholder'

export interface LightboxGalleryItem {
  url: string
  caption?: string
  source?: string
  date?: string
}

export default function LightboxGallery({ items, gridClassName, altBase, slug }: {
  items: LightboxGalleryItem[]
  gridClassName: string
  altBase: string
  slug: string
}) {
  const [openAt, setOpenAt] = useState<number | null>(null)
  if (!items.length) return null
  return (
    <>
      <div className={gridClassName}>
        {items.map((g, i) => (
          <figure key={i}>
            <button
              type="button"
              aria-label={`View photo ${i + 1} of ${items.length} full size`}
              onClick={() => setOpenAt(i)}
              style={{ display: 'block', width: '100%', padding: 0, margin: 0, border: 0, background: 'none', cursor: 'zoom-in', lineHeight: 0 }}
            >
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img src={g.url} alt={g.caption || `${altBase} photo ${i + 1}`} loading="lazy" />
            </button>
            {(g.caption || g.source) && (
              <figcaption>
                {g.caption}
                {g.source && <cite>Source: {g.source}{g.date ? ` · ${g.date}` : ''}</cite>}
              </figcaption>
            )}
          </figure>
        ))}
      </div>
      <PhotoLightbox
        photos={items.map((g) => g.url)}
        startIndex={openAt ?? 0}
        open={openAt !== null}
        onClose={() => setOpenAt(null)}
        placeholderSrc={masjidPlaceholder(slug)}
        altBase={altBase}
      />
    </>
  )
}
